/* global axios */
import ApiClient from '../ApiClient';

class TravelSearch extends ApiClient {
  constructor() {
    super('travel/searches', { accountScoped: true });
  }

  // POST rather than GET: the criteria are a structured payload (several passengers,
  // one leg per date) and Travelport meters look-to-book, so nothing here is cacheable.
  search(criteria) {
    return axios.post(this.url, { search: criteria });
  }
}

export default new TravelSearch();
